export const COURSES_BY_PAGE = 12;
export const COURSE_RULES_TRANSLATION_KEY = 'learn-dashboard-my-courses-rules';
export const ENROLLMENT_URL_SOURCES = {
  RECOMMENDED_COURSES: 'Recommended Courses',
} as const;
